export default {
  name: 'numberWithCommas',
  // 10000 => 10,000
  handler: number => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
}
